import { apiHandler } from "../buyerApiHandler";

export const getCampaigns = (page: number = 1, limit: number = 10) => apiHandler("get", `/admin/coupons/campaigns?page=${page}&limit=${limit}`);
export const getCampaignById = (id: string | number) => apiHandler("get", `/admin/coupons/campaigns/${id}`);

export const createCampaign = (payload: any) => apiHandler("post", `/admin/coupons/campaigns`, payload);

export const generateCampaignCodes = (id: string | number, payload: any) =>
  apiHandler("post", `/admin/coupons/campaigns/${id}/generate-codes`, payload);

// Distinct product names across all stores — for item-based coupons without a store.
export const getCommonItems = () => apiHandler("get", `/admin/coupons/common-items`);

export const updateCouponStatus = (id: string | number, status: "inactive" | "active") =>
  apiHandler("patch", `/admin/coupons/coupons/${id}/status`, { status });

export const getCampaignAnalyticsOverview = (params?: { from?: string; to?: string }) => {
  const from = params?.from ? encodeURIComponent(params.from) : "";
  const to = params?.to ? encodeURIComponent(params.to) : "";
  const query = from || to ? `?from=${from}&to=${to}` : "";
  return apiHandler("get", `/admin/coupons/analytics/overview${query}`);
};

export const getCampaignAnalyticsByCampaignId = (
  id: string | number,
  params?: { from?: string; to?: string }
) => {
  const from = params?.from ? encodeURIComponent(params.from) : "";
  const to = params?.to ? encodeURIComponent(params.to) : "";
  const query = from || to ? `?from=${from}&to=${to}` : "";
  return apiHandler("get", `/admin/coupons/analytics/campaigns/${id}${query}`);
};

export const updateCampaign = (id: string | number, payload: any) =>
  apiHandler("patch", `/admin/coupons/campaigns/${id}`, payload);

